<script setup lang="ts">
// types
import type { StrapiHeaderSingleMenu } from '@ts-strapi/interfaces'
// assets
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppText } from '@UI/Typography/AppText'
import { AppIcon } from '@UI/Icons/AppIcon'
import { LinkBase } from '@UI/Links/LinkBase'

interface HeaderSingleMenuProps {
  item: StrapiHeaderSingleMenu
}

defineOptions({
  name: 'HeaderSingleMenu',
})

defineProps<HeaderSingleMenuProps>()
</script>

<template>
  <div class="header-single-menu">
    <section
      v-for="block in item.blocks"
      :key="block.titleLink.url"
      class="header-single-menu__block"
    >
      <LinkBase
        :link="block.titleLink"
        class="header-single-menu__heading"
      >
        <AppText
          tag="span"
          name="body3-medium"
          color="slate-900"
        >
          {{ block.titleLink.label }}
        </AppText>
      </LinkBase>

      <ul class="header-single-menu__links">
        <li
          v-for="link in block.links"
          :key="link.url"
        >
          <LinkBase :link="link">
            <AppText
              tag="span"
              name="body2"
              color="slate-700"
            >
              {{ link.label }}
            </AppText>
          </LinkBase>
        </li>
        <li
          v-if="block.seeAllLink"
          class="header-single-menu__see-all"
        >
          <LinkBase :link="block.seeAllLink">
            <AppText
              tag="span"
              name="body2-medium"
              color="indigo-500"
            >
              {{ block.seeAllLink.label }}
            </AppText>
            <AppIcon
              :icon="faArrowRight"
              size="medium"
              color="indigo-500"
            />
          </LinkBase>
        </li>
      </ul>
    </section>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderSingleMenu.scss" />